import {
  Action,
  Button,
  Headline,
  Input,
  Line,
  useChameleonTheme,
} from "@petsapp/chameleon";
import useAuth from "@petsapp/use-auth";
import React from "react";
import { useState } from "react";
import styled from "styled-components";
import { useTranslation } from "../../utils/i18n";
import { FormType } from "./auth-controller";

interface LoginFormProps {
  setFormType: React.Dispatch<React.SetStateAction<FormType>>;
}

const ButtonWithMargin = styled.div`
  margin-bottom: 12px;
`;

const FormContainer = styled.form`
  margin-bottom: 40px;
`;

const LinkButtonAttrs = {
  as: "button",
  type: "button",
};

const LinkButton = styled(Action).attrs(() => LinkButtonAttrs)`
  background: transparent;
  padding: 0;
  border: none;
  cursor: pointer;
`;

export const LoginForm: React.FunctionComponent<LoginFormProps> = ({
  setFormType,
}) => {
  const auth = useAuth();
  // @ts-ignore
  const { chameleon } = useChameleonTheme();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState<string>();
  const [password, setPassword] = useState<string>();
  const [emailError, setEmailError] = useState<string>();
  const [passwordError, setPasswordError] = useState<string>();

  async function submit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();

    setEmailError(email ? undefined : "Please provide an email");
    setPasswordError(password ? undefined : "Please provide a password");

    if (!email || !password) {
      return;
    }

    setLoading(true);
    try {
      await auth.loginEmail({
        email,
        password,
      });
    } catch (e) {
      setPasswordError(e.description);
      setLoading(false);
    }
  }

  return (
    <React.Fragment>
      <FormContainer onSubmit={submit}>
        <Input
          id="email"
          error={emailError}
          onChange={(e) => setEmail(e.currentTarget.value)}
          label="Email"
          type="email"
        />
        <Input
          id="password"
          error={passwordError}
          onChange={(e) => setPassword(e.currentTarget.value)}
          label="Password"
          type="password"
        />
        <LinkButton
          onClick={() => setFormType("reset-password")}
          textColor={chameleon.color.Primary}
          marginBottomSize={3}
        >
          {t("Forgot password?")}
        </LinkButton>
        <Button
          type="submit"
          variant="primary"
          state={loading ? "loading" : undefined}
        >
          Sign in
        </Button>
      </FormContainer>
      <Line />
      <Headline marginBottomSize={2}>Sign in with</Headline>
      <ButtonWithMargin>
        <Button
          onClick={() => auth.loginGoogle()}
          width="100%"
          variant="google"
        >
          Google
        </Button>
      </ButtonWithMargin>
      <ButtonWithMargin>
        <Button
          onClick={() => auth.loginFacebook()}
          width="100%"
          variant="facebook"
        >
          Facebook
        </Button>
      </ButtonWithMargin>
    </React.Fragment>
  );
};
